module.exports = function getResource(label, vars = []) {
    let resources = {
        community: 'Collectivité',
        profile: 'Profil',
        groups: 'Groupes',
        gallery: 'Galerie',
        communityNavigation: 'Navigation dans la collectivité',
        notificationsFeed: 'Flux de notifications',
        startAConversation: 'Commencer une conversation',
        addAPhoto: 'Ajouter une photo',
        messages: 'Messages'
    };
    return resources[label];
};
